module.exports = __webpack_public_path__ + "img/expensesbadge@3x.1bbcb719.png";